var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.73 15.26L17.19 14.97C16.8913 14.9349 16.5886 14.968 16.3045 15.0667C16.0205 15.1654 15.7625 15.3273 15.55 15.54L13.71 17.38C10.8712 15.9362 8.56376 13.6288 7.11998 10.79L8.96998 8.94001C9.39998 8.51001 9.60998 7.91001 9.53998 7.30001L9.24998 4.78001C9.19329 4.29219 8.95917 3.84225 8.59222 3.51586C8.22526 3.18947 7.75109 3.00943 7.25998 3.01001H5.52998C4.39998 3.01001 3.45998 3.95001 3.52998 5.08001C4.05998 13.62 10.89 20.44 19.42 20.97C20.55 21.04 21.49 20.1 21.49 18.97V17.24C21.5 16.23 20.74 15.38 19.73 15.26Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCall);
export default __webpack_public_path__ + "static/media/icn-call.d9b0af297b87451f0d28691cb0d41980.svg";
export { ForwardRef as ReactComponent };